import { useQuery } from '@tanstack/react-query';
import { getAllHexagons } from '../apis/hexagons';
import type { HexagonData } from '../apis/hexagons';

/**
 * Query key factory for hexagon data
 */
export const hexagonKeys = {
    all: ['hexagons'] as const,
    allWithSubcategory: (subcategory: string) => [...hexagonKeys.all, 'all', subcategory] as const,
};

/**
 * Hook to fetch hexagons for the map selector.
 * Pass subcategories to get claimed status for any of them (claimedForSubcategory = union).
 */
export function useHexagonMap(subcategories?: string[]) {
    const key = (subcategories ?? []).slice().sort().join(',');
    return useQuery<HexagonData[], Error>({
        queryKey: hexagonKeys.allWithSubcategory(key),
        queryFn: () => getAllHexagons(subcategories),
        staleTime: 30 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: true,
    });
}

export type { HexagonData };
